import { render, staticRenderFns } from "./questionDetails.vue?vue&type=template&id=2d4a862b&scoped=true&"
import script from "./questionDetails.vue?vue&type=script&lang=js&"
export * from "./questionDetails.vue?vue&type=script&lang=js&"
import style0 from "./questionDetails.vue?vue&type=style&index=0&id=2d4a862b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4a862b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d4a862b')) {
      api.createRecord('2d4a862b', component.options)
    } else {
      api.reload('2d4a862b', component.options)
    }
    module.hot.accept("./questionDetails.vue?vue&type=template&id=2d4a862b&scoped=true&", function () {
      api.rerender('2d4a862b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmTool/userFeedback/components/questionDetails.vue"
export default component.exports